const BOM = '﻿';

function escapeCsvField(field: string): string {
    let escaped = field.replace(/"/g, '""');
    if (/^[=+\-@\t\r]/.test(escaped)) {
        escaped = "'" + escaped;
    }
    return `"${escaped}"`;
}

/**
 * Monta o conteúdo de um CSV a partir de cabeçalho + linhas, pronto para virar `Blob`.
 *
 * Separador `;` por padrão — é o que o Excel pt-BR espera. Todo campo entra entre aspas com `"`
 * interno escapado (`""`), então valores com vírgula, ponto e vírgula ou aspas não quebram a linha.
 */
export function toCsv(headers: string[], rows: string[][], separator = ';'): string {
    const lines = [headers, ...rows].map((line) =>
        line.map(escapeCsvField).join(separator)
    );

    return BOM + lines.join('\n');
}

/**
 * Gera o CSV e dispara o download no navegador.
 *
 * Usa BOM (acentos corretos no Excel) e libera a URL do blob ao final — os dois pontos que as
 * cópias manuais deste padrão em `Expenses` deixam passar.
 */
export function downloadCsv(filename: string, headers: string[], rows: string[][]): void {
    const csvContent = toCsv(headers, rows);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(url), 0);
}
